<template>
        <organisation-index>
            <template v-slot:title>
                <h1 class="mt-2 text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">Groups</h1>
            </template>
            <template v-slot:searchfilter>
                <search-filter :show-filter="false" v-model:value="form.search" class="w-1/2 max-w-md mr-4" @reset="reset"></search-filter>
            </template>
            <Head title="Groups"/>
            <div class="bg-white py-6 px-4 sm:p-6 shadow mb-6">
                <div class="flex flex-col mt-3 space-y-3">
                    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                            <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                <table class="min-w-full divide-y divide-gray-200">
                                    <thead class="bg-gray-50">
                                    <tr>
                                        <th scope="col"
                                            class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                            Name
                                        </th>
                                        <th scope="col"
                                            class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                            Assigned Entities
                                        </th>
                                        <th scope="col"
                                            class="px-6 py-3 text-left text-xs text-right text-gray-500 uppercase tracking-wider">
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-if="organisationGroups.data.length > 0"
                                        v-for="(group,index) in organisationGroups.data" :key="index"
                                        :class="{'bg-gray-100': index % 2}" class="hover:bg-gray-50 cursor-pointer">
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            <div class="text-sm text-gray-900" @click="openCreateGroup(group)">{{ group.name }}</div>
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            <span v-for="(organisation, index) in group.organisations" :key="index">
                                              <span>{{ organisation.name }}</span>
                                              <span v-if="index + 1 < group.organisations.length">, </span>
                                            </span>
                                        </td>
                                        <td class="flex px-6 py-4 whitespace-nowrap text-sm text-right text-gray-900 justify-content-end justify-end">
                                            <PencilAltIcon @click="openCreateGroup(group)" class="w-5 h-5 text-light-pitch-purple mr-3"></PencilAltIcon>
                                            <TrashIcon @click="deleteGroup(group.id)" class="w-5 h-5 text-red-500"></TrashIcon>
                                        </td>
                                    </tr>
                                    <tr v-else>
                                        <td colspan="8" class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 bg-gray-100">
                                            There are no groups available for your search criteria.
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </organisation-index>
</template>

<script>

import {mapActions} from "vuex";
import pickBy from "lodash/pickBy";
import debounce from "lodash/debounce";
import { router } from '@inertiajs/vue3'
import mapValues from "lodash/mapValues";
import Pagination from "@/Components/Pagination";
import { PlusSmIcon } from "@heroicons/vue/solid";
import {reactive, ref, watch, computed} from "vue";
import Authenticated from "@/Layouts/Authenticated";
import SearchFilter from "@/Components/SearchFilter";
import {useForm, usePage, Link, Head} from "@inertiajs/vue3";
import { PencilAltIcon, TrashIcon } from "@heroicons/vue/outline";
import OrganisationIndex from "@/Pages/Frontend/Organisations/Index"

export default {
    layout: Authenticated,
    components: {
        Link,
        Head,
        TrashIcon,
        Pagination,
        PlusSmIcon,
        SearchFilter,
        PencilAltIcon,
        OrganisationIndex
    },
    props: {
        organisationGroups: Object
    },
    data() {
        return {
            form: {
                search: null
            }
        }
    },
    methods: {
        reset() {
            this.form.search = null;
        },
        ...mapActions('organisations', [
            'openCreateGroup'
        ]),
        deleteGroup(id) {
            this.$swal.fire({
                title: 'Remove Group',
                html: "You are removing a group. <br/>Are you sure you'd like to do this?",
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                stopKeydownPropagation: true,
                keydownListenerCapture: true
            }).then((result) => {
                if (result.isConfirmed) {
                    // Trigger the loader
                    this.loading = true;
                    // Delete the contact
                    this.$inertia.delete(route('frontend.organisations.groups.delete', id), {
                        preserveScroll: true
                    });
                }
            });
        }
    },
    watch: {
        form: {
            deep: true,
            handler: debounce(function() {
                this.$inertia.get(route('frontend.organisations.groups.index'), pickBy(this.form), {
                    preserveState: true
                });
            }, 500),
        },
    }
}
</script>
